<template>
  <v-card class="pa-2" flat color="grey lighten-4" :style="{border: searchClickedPlotID === plotItem.PRC_ID ? '2px solid #2199a5 !important' : '1px solid white !important'}">
    <div class="pointer d-flex align-center text-uppercase" @click="viewPlotMap(plotItem.PRC_ID, index)">
      <img height="16" class="mr-1" :src="'/static/kantons/' + String(plotItem.CANTON).toLowerCase().replace(/\s+/g, '-') + '.png'" />
      <small> {{ plotPrefix }}-{{ plotItem.STATE?.substr(0, 2) }}-{{ plotItem.LOCNAME }}-{{ plotItem.PRC_NO }}</small>
      <v-spacer></v-spacer>
      <span v-if="plotItem.GRN_RAD > 10" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
    </div>
    <div @click="viewPlotMap(plotItem.PRC_ID, index)" class="d-flex flex-row align-end justify-content-between pointer">
      <canvas class="ma-2" :id="'canvas_' + plotItem.PRC_ID" width="64" height="64"></canvas>
      <div class="grey--text darken-5 flex text-right" style="font-size: 12px">
        {{ $t("size") }}: <span class="black--text">{{ plotItem.PRC_SUR }} m²</span>

        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{ plotItem.STREET_ADDRESS ? plotItem.STREET_ADDRESS.trim() : "-" }}</div>
      </div>
    </div>
    <div v-if="searchClickedPlotID === plotItem.PRC_ID" class="" style="position: absolute; left: 5px; bottom: 0">
      <span style="width: 10px; height: 10px; background-color: #2199a5; border-radius: 50%; display: inline-block"></span>
    </div>
  </v-card>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {config} from "./../../libs/utils"

@Component({
  components: {},
})
export default class PlotItemSelect extends Vue {
  plotPrefix = config.VUE_APP_PLOT_NUMBER_PREFIX

  @Prop()
  plotItem

  @Prop()
  index

  @Prop()
  searchClickedPlotID

  tab: any = []

  data: any = {
    items: [],
  }

  async created() {}

  async viewPlotMap(PRC_ID, index) {
    this.$emit("onClick", PRC_ID, index)
  }
}
</script>
